<template>
    <div class="FamilyRecord">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-2">
                    <div><img class="photo-border-square" v-bind:src="ProfilePhotoFileID" style="width:100%;border-radius:20px;" /></div>
                </div>
                <div class="col col-md-10">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ FamilyRecordData.Family.Name }}</span></h1>
                    <h4><span>{{ formatDate(FamilyRecordData.Family.FirstProgramMembershipDate, 'MM/DD/YY') }}</span><span> - </span><span>{{ formatDate(FamilyRecordData.FamilyProgramMembership.EndDate, 'MM/DD/YY', 'Present') }}</span></h4>
                    <!--<h4><span v-bind:class="FamilyRecordData.Family.Status == 'Approved' ? 'olive-green-text' : 'red'">{{ FamilyRecordData.Family.Status }} {{FamilyRecordData.Family.Status == 'Approved' ? formatDate(FamilyRecordData.Family.ApprovalDate, 'MM/DD/YY') : ''}} </span></h4>-->
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div>
                        <div class="record-tabs">
                            <span class="d-none d-sm-block">
                                <b-nav>
                                    <div v-for="pane in Panes">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                </b-nav>
                            </span>
                            <b-nav>
                                <span class="d-sm-none">
                                    <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                        <div v-for="pane in Panes">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                    </b-nav-item-dropdown>
                                </span>
                            </b-nav>
                        </div>
                        <div class="tab-content">
                            <div v-show="PaneShown == 'Summary'">
                                <ChildSummary v-bind:family-record-data="FamilyRecordData"/>
                            </div>
                            <div v-show="PaneShown == 'Family Info'">
                                <Information v-bind:family-record-data="FamilyRecordData" />
                            </div>
                            <div v-show="PaneShown == 'Program'">
                                <Program v-bind:family-record-data="FamilyRecordData" />
                            </div>
                            <div v-show="PaneShown == 'People'">
                                <People v-bind:family-record-data="FamilyRecordData" />
                            </div>
                            <div v-show="PaneShown == 'New Document'">
                            <NewDocument :form-memberships="SubProgramFormMemberships"
                                            :chart-record-id="FamilyRecordData.Family.Id" chart-type="FosterResourceFamily" />
                            </div>
                            <div v-show="PaneShown == 'Case File'">
                                <CaseFile chart-type="FosterResourceFamily"
                                          :chart-record-id="FamilyRecordData.Family.Id" />
                            </div>
                            <!--<div v-show="PaneShown == 'New Document'">
                                <NewDocument
                                    :form-memberships="SubProgramFormMemberships" 
                                    :chart-record-id="FamilyRecordData.Family.Id" />
                            </div>-->
                            <!--<div v-show="PaneShown == 'Audit'">
                                <Audit v-bind:child-record-data="ChildRecordData" />
                            </div>-->
                            <div v-show="PaneShown == 'Log'">
                                <CommunicationLog :family-record-data="FamilyRecordData"/>
                            </div>
                            <div v-show="PaneShown == 'Reports'">
                                <Reports :family-record-data="FamilyRecordData" />
                            </div>
                            <div v-show="PaneShown == 'Training'">
                                <FosterParentTraining :family-record-data="FamilyRecordData"/>
                            </div>
                            <div v-show="PaneShown == 'Admin'">
                                <Admin v-bind:family-record-data="FamilyRecordData" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Admin from "./Admin.vue";
    import Audit from "./Audit.vue";
    import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";
    import Information from "./Information.vue";
    import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import People from "./People.vue";
    import Program from "./Program.vue";
    import ChildSummary from "./Summary.vue";
    import CommunicationLog from "./CommunicationLog.vue";
    import FosterParentTraining from "./FosterParentTraining";
    import Reports from "./Reports.vue";
    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.FamilyRecordData.Id) {
                    vm.ProfilePhotoURL();
                    vm.GetSingleFamilyRecord();
                }
            });
             EventBus.$on('global-update-initiated', this.GetSingleFamilyRecord);
        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
            EventBus.$off('global-update-initiated');
        },
        props: [
            'FamilyRecordData'
        ],
        data: function () {
            return {
                PaneShown: "Summary",
                Panes: [
                    { name: 'Summary' },
                    { name: 'Family Info' },
                    { name: 'Program' },
                    { name: 'People' },
                    { name: 'Case File' },
                    { name: 'New Document' },
                    { name: 'Reports' },
                    { name: 'Log' },
                    { name: 'Admin' }
                ],
                ProfilePhotoFileID: this.ProfilePhotoURL()
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("Families.FamilyProfiles.Remove", "FamilyList", this.FamilyRecordData.Family.Id);
            },
            ProfilePhotoURL() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/ResourceFamily/GetPhotoID", { chartID: this.FamilyRecordData.Family.Id }, this.ProfilePhotoURLSuccess, () => { }, false);
            },
            ProfilePhotoURLSuccess(response) {
                if (response.data.data != null) {
                    this.ProfilePhotoFileID = this.$baseURL + '/API/Core/Files/GetFileContent/profilephoto?FileID=' + response.data.data;
                }
                else {
                    this.ProfilePhotoFileID = "/images/NoPhotoOnFile.jpg"
                }
            },
            GetSingleFamilyRecord() {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Families.FamilyProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Families.FamilyProfiles[key].Family.Id)
                });
                //vm.$store.commit("UI.BumpLoadsInProgress", 1);
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/GetResourceFamiliesSingularRecord",
                    {
                        SingleRecordID: vm.FamilyRecordData.Family.Id
                    }, this.GetSingleFamilyRecordSuccess, () => { }, false);
            },
            GetSingleFamilyRecordSuccess(response) {
                this.$store.commit("Families.FamilyEnrollmentsList.UpdateSingleRecord", response.data.data[0]);
            }
        },
        components: {
            Admin,
            Audit,
            CaseFile,
            Information,
            NewDocument,
            People,
            Program,
            ChildSummary,
            CommunicationLog,
            Reports,
            FosterParentTraining
        },
        mounted() {
            if (this.IsPNW) {
                this.Panes.push({ name: 'Training' });
            }
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.FamilyRecordData.FamilyProgramMembership.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "FosterResourceFamily");
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.FamilyRecordData.FamilyProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
    @media only screen and (max-width: 576px) {
        h4{
        font-size: 1em;
        }
        h1{
        font-size: 1.5em;
        }
    }
</style>